import { useEffect, useState } from "react";
import {
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { convertDate } from "../../../utils";
import { ConvertCurrency } from "../../../helpers/Currency/Currency";
import Icon from "../../../components/Icon/Icon";
import { convertCharter724FlightTypeToText } from "../../../utils/enum";

export default function FlightDetailsModal({ open, toggle, item }) {
    const [activeTab, setActiveTab] = useState('tDetails')

    const styleHandler = () => {
        const style = document.createElement('style');
        style.innerHTML = `
        .nav-link {
            font-size: 14px;
        }
        .nav-link.active {
            color: var(--orange) !important;
        }
        .nav-link.active::after {
            background: var(--orange);
            border-radius: 10px 10px 0 0;
            height: 5px;
        }
    `;
        document.head.appendChild(style);
    }

    useEffect(() => {
        styleHandler()
    }, [open])


    return (
        <>
            <Drawer
                open={open}
                onClose={toggle}
                direction="bottom"
                className="d-sm-none border-bottom-0"
                style={{ height: '70%', maxWidth: '450px', borderRadius: '25px 25px 0 0' }}
            >
                <div className="d-flex flex-column h-100 align-center justify-between px-4 py-2">
                    <div className="w-100 d-flex flex-column align-center">
                        <div className="rounded" style={{ height: '4px', width: '33%', background: 'rgba(233, 232, 233, 1)' }} />
                        {/* Flight Details */}
                        <div className="mt-4 w-100">
                            <div className="w-100 justify-between align-center fs-14px">
                                {/* <p className="m-0">{convertDate(item.date_flight)}</p> */}
                                <p className="mb-1">{convertDate(`2000/01/01 ${item.time_flight}`, "HH:mm")}</p>
                                {/* <p className="m-0">{convertDate(item.date_flight)}</p> */}
                                <div></div>
                            </div>

                            <div className="w-100 justify-between align-center fw-bold fs-18px">
                                <p className="m-0">{item.from}</p>
                                <div className="w-60 bg-red center d-flex">
                                    <div className="w-30"
                                        style={{ border: '2px dashed rgba(233, 232, 233, 1)', borderLeft: 'none', borderRight: 'none', borderBottom: 'none' }}
                                    ></div>
                                    <img src="/assets/images/icons/flight-airplane-circle.svg" alt='airplane' />
                                    <div className="w-30"
                                        style={{ border: '2px dashed rgba(233, 232, 233, 1)', borderLeft: 'none', borderRight: 'none', borderBottom: 'none' }}
                                    ></div>
                                </div>
                                <p>{item.to}</p>
                            </div>

                            <div className="w-100 justify-center">
                                <p className="text-muted mt-1">{convertDate(item.date_flight)}</p>
                                {/* <p className="text-muted">{convertDate(`2000/01/01 ${item.time_flight}`, "HH:mm")}</p> */}
                                {/* <p>{calculateDuration(`2000/01/01 ${item.time_flight}`, `2000/01/01 20:45:00`)}</p> */}
                                {/* <p>{convertDate(`2000/01/01 20:45:00`, "HH:mm")}</p> */}
                            </div>
                        </div>
                        {/* Flight Details End */}

                        <div className="w-100 mt-4">
                            <Nav tabs className="px-auto">
                                <NavItem className="d-flex w-50">
                                    <NavLink
                                        tag='a'
                                        href="#tab"
                                        className="w-100 justify-center"
                                        active={activeTab === "tDetails"}
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            setActiveTab("tDetails");
                                        }}
                                    >
                                        اطلاعات پرواز
                                    </NavLink>
                                </NavItem>
                                <NavItem className="d-flex w-50">
                                    <NavLink
                                        tag='a'
                                        href="#tab"
                                        className="w-100 justify-center"
                                        active={activeTab === "tRules"}
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            setActiveTab("tRules");
                                        }}
                                    >
                                        قوانین استرداد
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="tDetails">
                                    <div className="d-flex flex-column px-4" style={{ gap: '30px' }}>
                                        <div className="row">
                                            <div className='col'>
                                                <p className="mb-1">شماره پرواز</p>
                                                <p className="text-dark">{item.number_flight}</p>
                                            </div>
                                            <div className='col'>
                                                <p className="mb-1">کلاس کابین</p>
                                                <p className="text-dark">{item.displayLable}</p>
                                            </div>
                                            <div className='col'>
                                                <p className="mb-1">مدل هواپیما</p>
                                                <p className="text-dark">{item.carrier}</p>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className='col'>
                                                <p className="mb-1">مقدار بار مجاز</p>
                                                <p className="text-dark">20 کیلوگرم</p>
                                            </div>
                                            <div className='col'>
                                                <p className="mb-1">ترمینال</p>
                                                <p className="text-dark">2</p>
                                            </div>
                                            <div className='col'>
                                                <p className="mb-1">نوع پرواز</p>
                                                <p className="text-dark">{convertCharter724FlightTypeToText(item.type)}</p>
                                            </div>
                                        </div>
                                    </div>

                                </TabPane>
                                <TabPane tabId="tRules">
                                    <div className="d-flex flex-column mt-4">
                                        <p className="fs-13px">
                                            <span>
                                                <Icon name='info-fill' className='fs-19px' />
                                            </span>
                                            {' درصد جدیمه کسر شده بر اساس زمان اعلام کنسلی'}
                                        </p>

                                        <div className="d-flex justify-between mb-3 fs-12px border border-top-0 border-right-0 border-left-0">
                                            <p>از زمان صدور بلیط تا 12:00 ظهر 3 روز قبل از پرواز</p>
                                            <p className="text-danger fs-16px">{'50%-'}</p>
                                        </div>
                                        <div className="d-flex justify-between mb-3 fs-12px border border-top-0 border-right-0 border-left-0">
                                            <p>از 12:00 ظهر 3 روز قبل از پرواز تا 12:00 ظهر 2 روز قبل از پرواز</p>
                                            <p className="text-danger fs-16px">{'70%-'}</p>
                                        </div>
                                        <div className="d-flex justify-between mb-3 fs-12px border border-top-0 border-right-0 border-left-0">
                                            <p>از 12:00 ظهر 2 روز قبل از پرواز تا 12:00 ظهر 1 روز قبل از پرواز</p>
                                            <p className="text-danger fs-16px">{'85%-'}</p>
                                        </div>
                                        <div className="d-flex justify-between mb-3 fs-12px border border-top-0 border-right-0 border-left-0">
                                            <p>از 12:00 ظهر روز قبل از پرواز تا زمان پرواز</p>
                                            <p className="text-danger fs-16px">{'100%-'}</p>
                                        </div>
                                    </div>
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                    <div className="w-100">
                        <div className="w-100 d-flex justify-between">
                            <p>{'قیمت بزرگسال'}</p>

                            <p>
                                <ConvertCurrency
                                    price={Math.floor(item.price_final / 10)}
                                />
                                {' '}
                                <span className="text-muted fw-light fs-12px">ريال</span>
                            </p>
                        </div>
                        <Button
                            size="lg"
                            className="bg-orange w-100 center no-bdr py-3 rounded-xl fw-normal"
                        >
                            {'ادامه و تنظیمات پرداخت'}
                        </Button>
                    </div>
                </div>

            </Drawer >
        </>
    )
}